import React, { useState, useEffect } from "react";
import "./Menu.css";

const Menu = () => {
    const [selectedCategory, setSelectedCategory] = useState("category1");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getImageSource = () => {
        if (windowWidth < 800) {
            return "/menu/mcoffee.jpg";
        } else {
            return "/menu/coffee1.jpg";
        }
    };

    const getCategoryImageSource = () => {
        if (windowWidth < 800) {
            return "/menu/CLASSICS2.jpg";
        } else {
            return "/menu/CLASSICS.jpg";
        }
    };

    const getCategory2ImageSource = () => {
        if (windowWidth < 800) {
            return "/menu/CHILLERS2.jpg";
        } else {
            return "/menu/CHILLERS.jpg";
        }
    };

    return (
        <div className="container-menu">
            <div className="image-container">
                <img src={getImageSource()} alt="Your Image" />
            </div>
            <div className="menu-bar">
                <button
                    className={`category ${selectedCategory === "category1" ? "active" : ""}`}
                    onClick={() => handleCategoryChange("category1")}
                >
                    Category 1
                </button>
                <button
                    className={`category ${selectedCategory === "category2" ? "active" : ""}`}
                    onClick={() => handleCategoryChange("category2")}
                >
                    Category 2
                </button>
            </div>

            <div className="selected-image">
                {selectedCategory === "category1" && (
                    <img src={getCategoryImageSource()} alt="Category 1 Image" />
                )}
                {selectedCategory === "category2" && (
                    <img src={getCategory2ImageSource()} alt="Category 2 Image" />
                )}
            </div>
        </div>
    );
};

export default Menu;
